// avstemming-loans-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avdl.toast.noBackend': 'The loan register is not connected to the backend.',
  'avdl.toast.registered': 'The loan has been registered',
  'avdl.toast.saved': 'The loan has been saved',
  'avdl.toast.removed': 'The loan has been removed from the register',
  'avdl.toast.noAccount': 'The loan area has no reconciliation account in this period.',
  'avdl.nav.accounting': 'Accounting data',
  'avdl.nav.register': 'Loan overview',
  'avdl.nav.loansCount': '{count} loans',
  'avdl.nav.documents': 'External evidence',
  'avdl.nav.missingCount': '{count} missing',
  'avdl.nav.complete': 'Complete',
  'avdl.nav.difference': 'Difference calculation',
  'avdl.nav.verified': 'Verified',
  'avdl.nav.items': 'Reconciliation items',
  'avdl.nav.openCount': '{count} open',
  'avdl.nav.classification': 'Classification',
  'avdl.nav.noPlan': 'No plan',
  'avdl.nav.controls': 'Review and conclusion',
  'avdl.area.loans': 'Loans and debt',
  'avdl.header.hintMissing': '{count} loans lack valid documentation for the period.',
  'avdl.header.hintAll': 'All registered loans have evidence for the period.',
  'avdl.header.title': 'Loans and debt — register, lender\'s balance and classification',
  'avdl.header.responsible': 'Responsible: {name}',
  'avdl.header.unverified': '{amount} not verified',
  'avdl.header.allVerified': 'All balances are verified',
  'avdl.header.summary': '{count} registered loans with a total booked balance of {amount}.',
  'avdl.header.summaryUnverified': '{amount} of this cannot be verified because valid documentation from the lender is missing for the period.',
  'avdl.header.summaryVerified': 'All balances are verified against documentation from the lender.',
  'avdl.header.zeroDiffNote': 'A difference of zero is not the same as a reconciled debt. A booked balance that no lender has confirmed is shown as not verified, and is not counted as reconciled no matter what the other loans show.',
  'avdl.header.noAccountAlert': 'The area has no reconciliation account in this period. Documentation and reconciliation items therefore cannot be saved until a debt account is part of the period.',
  'avdl.status.unverified': 'Not verified',
  'avdl.status.incomparable': 'Cannot be compared',
  'avdl.status.hasDifference': 'Has a difference',
  'avdl.status.reconciled': 'Reconciled',
  'avdl.acc.title': 'Accounting data',
  'avdl.acc.source': 'Taken from the trial balance',
  'avdl.acc.sourceAt': 'Taken from the trial balance as of {date}',
  'avdl.acc.booked': 'Booked loan and debt balance',
  'avdl.acc.opening': 'Balance previous period',
  'avdl.acc.change': 'Change this period',
  'avdl.acc.loanCount': 'Number of registered loans',
  'avdl.acc.unverified': 'Unverified booked balance',
  'avdl.acc.classificationGap': 'Possible classification deviation',
  'avdl.acc.hideAccounts': 'Hide account overview',
  'avdl.acc.showAccounts': 'Show account overview',
  'avdl.acc.colAccount': 'Account',
  'avdl.acc.colClass': 'Classification',
  'avdl.acc.colOpening': 'Opening',
  'avdl.acc.colMovement': 'Movement',
  'avdl.acc.colBooked': 'Booked balance',
  'avdl.acc.longTerm': 'Long-term debt',
  'avdl.acc.shortTerm': 'Short-term debt',
  'avdl.acc.unreadable': 'Not determined from the account number',
  'avdl.acc.noAccounts': 'No loan or debt accounts in this period.',
  'avdl.flag.unverified': 'Not verified with the lender',
  'avdl.flag.difference': 'Difference against the lender',
  'avdl.flag.noPlan': 'Missing repayment plan',
  'avdl.flag.foreign': 'Loans in a currency other than NOK',
  'avdl.flag.sharesAccount': 'Shares a general ledger account',
  'avdl.tile.unverifiedHint': 'Loans without a balance confirmation or loan statement covering the period end.',
  'avdl.tile.withDifference': 'Loans with a difference',
  'avdl.tile.withDifferenceHint': 'Verified loans where the booked balance and the lender\'s balance are not the same.',
  'avdl.tile.noPlanHint': 'Without a repayment plan the short-term portion cannot be determined.',
  'avdl.tile.foreign': 'Loans in another currency',
  'avdl.tile.foreignHint': 'The exchange rate on the balance sheet date must be checked.',
  'avdl.tile.sharesAccountHint': 'Several loans on the same account. The account balance is then not one loan\'s booked balance, and the difference cannot be calculated per loan.',
  'avdl.tile.unregistered': 'Debt accounts without a loan',
  'avdl.tile.unregisteredHint': 'Balance on a debt account with no registered loan behind it. Listed below the loan overview.',
  'avdl.card.title': 'Control card',
  'avdl.card.loans': 'Registered loans: {count}',
  'avdl.card.verified': 'Verified with the lender: {count}',
  'avdl.card.unexplained': 'Unexplained difference: {amount}',
  'avdl.card.activeFilter': 'Active filter: {label}',
  'avdl.card.removeFilter': 'Remove filter',
  'avdl.reg.resetFilter': 'Reset filter',
  'avdl.reg.newLoan': 'Register loan',
  'avdl.reg.note': 'The loans are kept in the company\'s setup, like the bank accounts. A loan registered here stays in the loan register and is also used by the balance sheet statement.',
  'avdl.reg.colLoan': 'Lender / loan',
  'avdl.reg.colAccount': 'Account',
  'avdl.reg.colBooked': 'Booked balance',
  'avdl.reg.colDocumented': 'Documented balance',
  'avdl.reg.colDifference': 'Difference',
  'avdl.reg.colDocumentation': 'Documentation',
  'avdl.reg.colStatus': 'Status',
  'avdl.reg.sharedWithOther': 'Shared with another loan',
  'avdl.reg.shared': 'Shared',
  'avdl.reg.open': 'Open',
  'avdl.reg.noMatch': 'No loans match the filter.',
  'avdl.reg.noLoans': 'No loans are registered. If debt is booked on the accounts above, the loans must be registered before the short-term portion can be determined.',
  'avdl.reg.unregisteredOne': 'One debt account has a balance without a registered loan: {accounts}. Without a repayment plan the short-term portion cannot be determined.',
  'avdl.reg.unregisteredMany': '{count} debt accounts have a balance without a registered loan: {accounts}. Without a repayment plan the short-term portion cannot be determined.',
  'avdl.cls.title': 'Classification of debt',
  'avdl.cls.bookedTotal': 'Total booked debt',
  'avdl.cls.verifiedDebt': 'Documented and verified debt',
  'avdl.cls.unverifiedDebt': 'Unverified debt',
  'avdl.cls.bookedLong': 'Booked as long-term',
  'avdl.cls.bookedShort': 'Booked as short-term',
  'avdl.cls.documentedNext12': 'Documented instalments next 12 months',
  'avdl.cls.plannedNext12': 'Instalments next 12 months according to the plans',
  'avdl.cls.noPlan': 'No plan',
  'avdl.cls.countryNote': 'The distinction between short-term and long-term debt is read from the Norwegian chart of accounts. The accounting country is {country}, so the classification must be assessed manually.',
  'avdl.cls.unclassified': '{amount} of the booked debt is on accounts outside both long-term and short-term debt. The account must be moved, or the area has been set up with an account that is not debt.',
  'avdl.cls.missingPlanOne': 'One loan is missing a repayment plan. Without the plan the instalments for the next twelve months cannot be calculated, and the field is left empty instead of being guessed.',
  'avdl.cls.missingPlanMany': '{count} loans are missing a repayment plan. Without the plan the instalments for the next twelve months cannot be calculated, and the field is left empty instead of being guessed.',
  'avdl.cls.provisional': 'Provisional – must be confirmed against an updated repayment plan',
  'avdl.cls.gapNote': 'Instalments of {amount} fall due in the next 12 months according to the loans\' own plans, but are not booked as short-term debt. The reclassification is the firm\'s assessment — interest-only periods, breaches of loan covenants and refinancing after the balance sheet date change the answer without the plan showing it. If the assessment is that the debt should be moved, it is registered as a reconciliation item with the classification «Feil kortsiktig/langsiktig klassifisering».',
  'avdl.derived.registered': 'All debt accounts with a balance have a registered loan',
  'avdl.derived.registeredOpen': '{count} account without a loan',
  'avdl.derived.registeredNone': 'No debt account is without a loan',
  'avdl.derived.documented': 'All loans have valid documentation for the period',
  'avdl.derived.documentedOpen': '{count} loans lack valid evidence',
  'avdl.derived.documentedNone': 'All loans are documented',
  'avdl.derived.difference': 'The difference against the lenders is explained',
  'avdl.derived.differenceOpen': '{amount} is unexplained',
  'avdl.derived.differenceNone': 'No unexplained difference',
  'avdl.derived.interest': 'Accrued interest and fees have been handled',
  'avdl.derived.interestOpen': '{amount} is reported but not booked',
  'avdl.derived.interestNone': 'Nothing is reported as unbooked',
  'avdl.derived.plan': 'All loans have a repayment plan to classify by',
  'avdl.derived.planOpen': '{count} loans lack a plan',
  'avdl.derived.planNone': 'All loans have a plan',
  'avdl.derived.classification': 'The short-term portion is in line with the plans',
  'avdl.derived.classificationOpen': '{amount} falls due without being booked as short-term',
  'avdl.derived.classificationNone': 'No difference from the plans',
  'avdl.blocker.unregisteredOne': 'One debt account with a balance has no registered loan',
  'avdl.blocker.unregisteredMany': '{count} debt accounts with a balance have no registered loan',
  'avdl.blocker.documentation': 'Valid documentation is missing for {count} loans',
  'avdl.blocker.unverified': 'A booked balance of {amount} is not verified',
  'avdl.blocker.difference': '{amount} of the difference against the lenders is unexplained',
  'avdl.blocker.accrued': 'Accrued interest and fees of {amount} must be handled',
  'avdl.blocker.classification': 'A possible classification deviation of {amount} must be confirmed',
  'avdl.blocker.pointOne': 'One control point remains',
  'avdl.blocker.pointMany': '{count} control points remain',
  'avdl.checks.title': 'Checks',
  'avdl.checks.colCheck': 'Check',
  'avdl.checks.colFindings': 'Findings',
  'avdl.checks.colStatus': 'Status',
  'avdl.checks.needsReview': 'Needs review',
  'avdl.checks.none': 'No findings',
  'avdl.check.title': 'Professional checklist',
  'avdl.check.titleReadOnly': 'Professional checklist (preparer\'s, read-only)',
  'avdl.check.noPoints': 'No control points are defined for loans and debt in this period.',
  'avdl.check.scope': 'The points apply to the whole area. A tick is saved on all the debt accounts in the period.',
  'avdl.check.groupDerived': 'Follows from the loans',
  'avdl.check.groupAssessments': 'Professional assessments',
  'avdl.check.groupReady': 'Readiness',
  'avdl.check.count': '{done} of {total}',
  'avdl.check.followsNumbers': 'Follows from the figures',
  'avdl.check.performedBy': 'Performed by {name}',
  'avdl.check.completed': '{done} of {total} control points completed',
  'avdl.concl.title': 'Conclusion and approval',
  'avdl.concl.loansChecked': 'Loans checked',
  'avdl.concl.loansWithoutDocs': 'Loans without valid documentation',
  'avdl.concl.unexplainedDifference': 'Unexplained reconciliation difference',
  'avdl.concl.accrued': 'Accrued interest and fees',
  'avdl.concl.conclusion': 'Conclusion',
  'avdl.concl.placeholder': 'What does the review of loans and debt show for this period?',
  'avdl.concl.savedAs': 'Saved as the justification on the control point «{label}».',
  'avdl.concl.remainingRisk': 'Remaining risk',
  'avdl.concl.noRisk': 'Nothing remains that prevents the area from being sent for review.',
  'avdl.concl.followUp': 'Follow-up next period',
  'avdl.concl.noFollowUp': 'No items are marked for follow-up, and all loans have evidence for the period.',
  'avdl.concl.missingEvidence': 'Missing evidence',
  'avdl.concl.getStatement': 'Obtain an updated loan statement. {status}.',
  'avdl.common.openLoan': 'Open the loan',
  'avdl.concl.reconItem': 'Reconciliation item',
  'avdl.common.followed': 'Follow up',
  'avdl.concl.measure': 'Action: {text}',
  'avdl.concl.noMeasure': 'No action noted',
  'avdl.concl.deadline': 'Deadline {date}',
  'avdl.concl.send': 'Send the area for review',
  'avdl.concl.oneLeft': 'One thing remains before the area can be sent.',
  'avdl.concl.manyLeft': '{count} things remain before the area can be sent.',
  'avdl.docs.title': 'External evidence',
  'avdl.docs.unverifiedNote': '{amount} of the booked debt cannot be verified because valid documentation from the lender is missing for the period:',
  'avdl.docs.colDocument': 'Document',
  'avdl.docs.colType': 'Type',
  'avdl.docs.colBalanceDate': 'Balance date',
  'avdl.docs.colLender': 'Lender',
  'avdl.docs.notLinked': 'Not linked to a loan',
  'avdl.docs.view': 'View',
  'avdl.docs.uploaded': 'Uploaded:',
  'avdl.docs.source': 'Source:',
  'avdl.docs.sourceClient': 'The client',
  'avdl.docs.sourceFirm': 'The firm',
  'avdl.docs.by': 'By:',
  'avdl.docs.accounts': 'Accounts:',
  'avdl.docs.loanStatement': 'Loan statement',
  'avdl.docs.requestDocs': 'Ask the client for documentation',
  'avdl.docs.empty': 'No documentation has been attached in the loan area in this period.',
  'avdl.docs.footer': 'Documents are uploaded in the documents tab in the right-hand panel and linked to the loan in the loan drawer — where the balance and balance date read from the document are also registered.',
  'avdl.diff.critical': 'Critical deviation – must be resolved before approval',
  'avdl.diff.unexplained': 'Unexplained difference',
  'avdl.diff.difference': 'Difference',
  'avdl.diff.partA': 'A. Reconciliation of documented loans',
  'avdl.diff.bookedCovered': 'Booked balance covered by documentation',
  'avdl.diff.documentedFromLenders': 'Documented balance from lenders',
  'avdl.diff.preliminary': 'Preliminary difference',
  'avdl.diff.explained': 'Explained differences',
  'avdl.diff.unexplainedLabel': 'Unexplained difference',
  'avdl.diff.noneVerified': 'No loans have valid documentation for the period yet. There is then nothing to reconcile here — the whole balance is under B.',
  'avdl.diff.partB': 'B. Balance that is not verified',
  'avdl.diff.criticalDocs': 'Critical – documentation missing',
  'avdl.diff.unverifiedBooked': 'Booked balance that is not verified',
  'avdl.diff.debtWithoutLoan': 'Debt accounts without a registered loan',
  'avdl.diff.notADifference': 'This is not a difference. It is debt that no external source has confirmed, and it therefore cannot be set to «reconciled» just because the figures happen to agree with each other.',
  'avdl.diff.requestDocsCustomer': 'Ask the customer for documentation',
  'avdl.diff.partC': 'C. Other open matters',
  'avdl.diff.accruedInterest': 'Accrued interest not booked',
  'avdl.diff.fees': 'Fees not booked',
  'avdl.diff.foreign': 'Loans in foreign currency',
  'avdl.diff.possibleMisclass': 'Possible incorrect short-term/long-term classification',
  'avdl.diff.footerNote': 'Identified matters are not counted as resolved or explained items until the action has been carried out or documented. The amounts here are reported on the loans, not booked.',
  'avdl.items.title': 'Reconciliation items',
  'avdl.items.noAccount': 'The area has no reconciliation account in this period, so the items cannot be saved.',
  'avdl.items.note': 'The items explain the difference against the lenders. The amount and the justification are what count in the calculation — an item without a justification explains nothing.',
  'avdl.items.description': 'Description',
  'avdl.items.noLoan': 'Not linked to a loan',
  'avdl.items.amount': 'Amount',
  'avdl.items.add': 'Add',
  'avdl.items.colLoan': 'Loan',
  'avdl.items.colDate': 'Date',
  'avdl.items.colAction': 'Action',
  'avdl.items.resolved': 'Resolved',
  'avdl.items.open': 'Open',
  'avdl.items.reopen': 'Reopen',
  'avdl.items.markResolved': 'Mark as resolved',
  'avdl.items.delete': 'Delete',
  'avdl.items.empty': 'No reconciliation items registered.',
  'avdl.carry.title': 'Carry the balance forward to period end',
  'avdl.drawer.close': 'Close',
  'avdl.carry.note': 'The lender\'s balance on the document date, rolled forward with what happened afterwards. Instalments reduce the debt; new drawdowns, interest and fees increase it.',
  'avdl.carry.baseBalance': 'Balance per the document',
  'avdl.carry.baseDate': 'Document balance date',
  'avdl.carry.installments': 'Instalments after the document date',
  'avdl.carry.drawdowns': 'New drawdowns',
  'avdl.carry.interestAndFees': 'Interest and fees',
  'avdl.carry.other': 'Other movements',
  'avdl.carry.computed': 'Calculated balance at period end',
  'avdl.carry.comparedToLedger': 'Compared with the general ledger',
  'avdl.carry.apply': 'Use the carried-forward balance in the reconciliation',
  'avdl.carry.cancel': 'Cancel',
  'avdl.drawer.loanFallback': 'Loan',
  'avdl.drawer.noLoanNumber': 'No loan number',
  'avdl.drawer.accountPrefix': 'account {account}',
  'avdl.drawer.loanHeading': 'The loan',
  'avdl.drawer.loanNote': 'Saved in the company\'s loan register and applies to all periods.',
  'avdl.drawer.lender': 'Lender',
  'avdl.drawer.loanName': 'Loan name',
  'avdl.drawer.loanNumber': 'Loan number',
  'avdl.drawer.ledgerAccount': 'General ledger account',
  'avdl.drawer.ledgerAccountHint': 'The account the loan is booked on',
  'avdl.drawer.chooseAccount': 'Choose account',
  'avdl.drawer.currency': 'Currency',
  'avdl.drawer.originalAmount': 'Original loan amount',
  'avdl.drawer.interestRate': 'Interest rate',
  'avdl.drawer.repaymentType': 'Repayment type',
  'avdl.drawer.termsPerYear': 'Terms per year',
  'avdl.drawer.monthly': 'Monthly',
  'avdl.drawer.quarterly': 'Quarterly',
  'avdl.drawer.semiannual': 'Semi-annual',
  'avdl.drawer.annual': 'Annual',
  'avdl.drawer.installmentAmount': 'Instalment amount',
  'avdl.drawer.remainingTerms': 'Remaining terms',
  'avdl.drawer.startDate': 'Start date',
  'avdl.drawer.endDate': 'End date',
  'avdl.drawer.interestOnlyUntil': 'Interest-only until',
  'avdl.drawer.security': 'Security/collateral',
  'avdl.drawer.next12': 'Instalments next 12 months according to the plan',
  'avdl.drawer.planInsufficient': 'The plan is insufficient',
  'avdl.drawer.bookedOnAccount': 'Booked balance on the account',
  'avdl.drawer.needsAccount': 'The loan must be on a general ledger account.',
  'avdl.drawer.saveLoan': 'Save the loan',
  'avdl.drawer.removeLoan': 'Remove the loan from the register',
  'avdl.drawer.periodDocs': 'Documentation for the period',
  'avdl.drawer.periodDocsNote': 'The lender\'s balance for this period. Saved on the reconciliation, not on the loan.',
  'avdl.drawer.lenderBalance': 'Balance per the lender',
  'avdl.drawer.balanceDate': 'Balance date',
  'avdl.drawer.periodEndIs': 'Period end is {date}',
  'avdl.drawer.lenderPerDoc': 'Lender per the document',
  'avdl.drawer.linkedDoc': 'Linked document',
  'avdl.drawer.notLinked': 'Not linked',
  'avdl.drawer.accruedInterest': 'Accrued, unbooked interest',
  'avdl.drawer.fees': 'Fees not booked',
  'avdl.drawer.docIssue': 'Objection to the document',
  'avdl.drawer.comment': 'Comment',
  'avdl.drawer.commentPlaceholder': 'What does the documentation show, and what remains?',
  'avdl.drawer.documentDate': 'the document date',
  'avdl.drawer.carriedNote': 'The balance is carried forward from {date}: {base} − instalments {installments} + drawdowns {drawdowns} + interest and fees {fees} + other {other}.',
  'avdl.drawer.saveDocs': 'Save the documentation',
  'avdl.drawer.carryForward': 'Carry the balance forward to period end',
});
